'use client';

import React, { forwardRef } from 'react';
import { IconButton, iconButtonVariants } from '@paypoteam/ui-components';
import { List } from '@phosphor-icons/react';
import Link from 'next/link';

import type { NavigationConfigType } from '@/components/organisms/Navigation/Navigation.types';

interface MobileControlsProps {
    mobileControls?: NavigationConfigType['mobileControls'];
    handleMenuOpen?: () => void;
}

const MobileControls = forwardRef<HTMLDivElement, MobileControlsProps>(
    ({ mobileControls, handleMenuOpen }, ref) => (
        <div
            className="flex gap-x-3"
            ref={ref}
        >
            {!!mobileControls &&
                mobileControls.map(({ href, icon, ariaLabel }, i) => (
                    <Link
                        key={`${href}_${i}`}
                        href={href}
                        className={iconButtonVariants({
                            size: 'm',
                            variant: 'tonal',
                        })}
                        aria-label={ariaLabel}
                        // onClick={() => {
                        //     Sentry.addBreadcrumb({
                        //         category: 'navigation',
                        //         message: 'click to menu link ' + href,
                        //         level: 'info',
                        //     });
                        // }}
                    >
                        {icon}
                    </Link>
                ))}

            <IconButton
                size="m"
                variant="tonal"
                onClick={handleMenuOpen}
                aria-label="Otwórz menu mobilne"
            >
                <List weight="bold" />
            </IconButton>
        </div>
    ),
);

export default MobileControls;
